export default __webpack_public_path__ + "static/media/bg-tublian.0ecf2561.svg";